export default __webpack_public_path__ + "static/media/vincennes5.93bf49df.jpg";